import axios from 'axios';
import {
    GET_VEHICLE_REQUEST,
    GET_VEHICLE_SUCCESS,
    GET_VEHICLE_FAIL,
    GET_VEHICLES_REQUEST,
    GET_VEHICLES_SUCCESS,
    GET_VEHICLES_FAIL,
    CREATE_VEHICLE_REQUEST,
    CREATE_VEHICLE_SUCCESS,
    CREATE_VEHICLE_FAIL
} from '../constants/vehicleConstants';

export const getVehicle = (vehicleNo) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_VEHICLE_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/vehicles/${vehicleNo}`, config);

        dispatch({
            type: GET_VEHICLE_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: GET_VEHICLE_FAIL,
            payload: 'An error Occurred'
        });
    }
};

export const getVehicles = () => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_VEHICLES_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/vehicles`, config);

        dispatch({
            type: GET_VEHICLES_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: GET_VEHICLES_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const createNewVehicle = (customer, districtCode, vehicleLetters, vehicleNumber, chassisNo, make, model, yom, mileage) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: CREATE_VEHICLE_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`,
                'Content-Type': 'application/json'
            },
        };

        const formData = {
            customer,
            vehicleInfo: {
                vehicleNo: districtCode.toUpperCase() + "-" + vehicleLetters.toUpperCase() + "-" + vehicleNumber.toUpperCase(),
                chassisNo,
                make,
                model,
                YOM: yom,
                lastMileage: mileage
            }
        }

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/vehicles`, formData, config);

        dispatch({
            type: CREATE_VEHICLE_SUCCESS,
            payload: data
        });

    } catch (error) {
        console.log(error)
        dispatch({
            type: CREATE_VEHICLE_FAIL,
            payload: 'An error Occurred'
        });
    }
};
